import { Routes } from '@angular/router';
import {
  authGuard,
  eidAuthorizationGuard,
  portalAccessGuard,
  portalContextResolver,
  setCasesNavigationResolver,
  setInvestigationsNavigationResolver,
} from '@core';
import { noAgencyGuard } from './core/guards/no-agency.guard';

export const routes: Routes = [
  {
    path: 'local-login',
    title: 'Sign In',
    loadComponent: () => import('./presentation/pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'unauthorized',
    title: 'Unauthorized',
    loadComponent: () =>
      import('./presentation/pages/unauthorized/unauthorized.page').then((m) => m.UnauthorizedPage),
  },
  {
    path: 'no-agency',
    title: 'No Agency',
    canActivate: [noAgencyGuard],
    loadComponent: () =>
      import('./presentation/pages/no-agency/no-agency.page').then((m) => m.NoAgencyPage),
  },
  {
    path: '',
    canActivate: [eidAuthorizationGuard, authGuard],
    children: [
      {
        path: '',
        redirectTo: '/employee',
        pathMatch: 'full',
      },
      {
        path: 'employee',
        loadChildren: () =>
          import('./presentation/pages/employee-workspace/employee-portal.routes').then(
            (m) => m.employeePortalRoutes,
          ),
      },
      {
        path: 'cases',
        canActivate: [portalAccessGuard],
        resolve: {
          portalType: portalContextResolver,
          navigation: setCasesNavigationResolver,
        },
        loadComponent: () =>
          import('./presentation/pages/portal-shell').then((m) => m.PortalShellPage),
        loadChildren: () =>
          import('./presentation/pages/cases/cases.routes').then((m) => m.casesRoutes),
      },
      {
        path: 'investigations',
        canActivate: [portalAccessGuard],
        resolve: {
          portalType: portalContextResolver,
          navigation: setInvestigationsNavigationResolver,
        },
        loadComponent: () =>
          import('./presentation/pages/portal-shell').then((m) => m.PortalShellPage),
        loadChildren: () =>
          import('./presentation/pages/investigations/investigations.routes').then(
            (m) => m.investigationsRoutes,
          ),
      },
    ],
  },
];
